import { DatePipe } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { statusConstant } from 'src/app/app.constant';
import { AlertModal, auditTrailHeader } from 'src/app/app.model';
import { DataSharedService } from 'src/app/services/data-shared.service';
import { TimesheetService } from 'src/app/services/timesheet.service';
import { AlertModalComponent } from '../alert-modal/alert-modal.component';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-audit-trail',
  templateUrl: './audit-trail.component.html',
  styleUrls: ['./audit-trail.component.css'],
})
export class AuditTrailComponent implements OnInit {
  @Input() header!: auditTrailHeader;
  @Input() type!: string;
  @Input() uuid!: string;
  @Input() from!: string;
  @Input() auditTrailActivities?: any;
  isModalCloseIcon = false;
  loading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private timesheetService: TimesheetService,
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<AuditTrailComponent>,
    public dataSharedService: DataSharedService,
  ) {
    if (!this.header) {
      this.type = data?.type;
      this.uuid = data?.uuid;
      this.header = data?.header;
    }
    this.isModalCloseIcon = data.isIcon;
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    await this.getAuditTrailData();
    this.loading = false;
  }

  getAuditTrailData() {
    return new Promise(async (resolve) => {
      if (!this.auditTrailActivities) {
        this.auditTrailActivities = await new Promise(resolve => this.timesheetService.getAuditTrail(this.type, this.uuid).subscribe((res: any) => resolve(res.data)))
      }
      this.auditTrailActivities.forEach((activity: any) => {
        activity.day = this.datePipe.transform(activity.event_date, 'EEEE');
        // activity.time = this.datePipe.transform(
        //   activity.event_date,
        //   'hh:mm a'
        // );
        activity.time = moment.utc(activity.event_date).tz(moment.tz.guess()).format("hh:mm A ");
        if (this.type === 'timesheet') {
          if (
            activity?.new_values?.status === statusConstant.SUBMITTED &&
            activity?.old_values?.status &&
            activity?.old_values?.status !== statusConstant.PENDING
          ) {
            activity.text = 'edited the timesheet';
          } else {
            activity.text = `${activity?.new_values?.status} a timesheet`;
          }
          if (activity?.new_values?.approved_via) {
            activity.text += ` via ${activity.new_values.approved_via}`;
          }
        } else if (this.type === 'job') {
          if(activity?.new_values?.is_active == 3) {
            activity.text = `submitted the onboarding form details`;
          } else if(activity?.new_values?.is_active == 1) {
            activity.text = `approved the onboarding form details & job moved to Active`;
          } else if(activity?.new_values?.is_active == 4) {
            activity.text = `rejected the onboarding form details`;
          } else if(activity?.new_values?.is_active == 5) {
            activity.text = `permanent rejected the onboarding form details`;
          } else if(activity?.new_values?.is_active == 6) {
            activity.text = `resubmitted the onboarding form details`;
          } else {
            activity.text = `added the job ${activity?.new_values?.name}`;
          }
        } else if (this.type === 'invoice') {
          activity.text = this.describeInvoiceChange(activity);
        }
      });
      resolve(true);
    });
  }

  /**
   * Turns an invoice audit entry into a plain-English sentence a layman can read,
   * e.g. "changed the invoice date from 10 Jul 2026 to 12 Jul 2026 and set the PO number to PO-99".
   */
  private describeInvoiceChange(activity: any): string {
    if (activity?.event === 'created') {
      return 'created the invoice';
    }

    // Sending an invoice is recorded as a change to its send-status flag.
    if (activity?.new_values?.contractor_sent !== undefined) {
      return 'sent the contractor invoice';
    }
    if (activity?.new_values?.client_sent !== undefined) {
      return 'sent the client invoice';
    }

    const fields: any = {
      invoice_date: { label: 'invoice date', type: 'date' },
      client_invoice_date: { label: 'invoice date', type: 'date' },
      due_date: { label: 'due date', type: 'date' },
      client_due_date: { label: 'due date', type: 'date' },
      invoice_number: { label: 'invoice number', type: 'text' },
      client_invoice_number: { label: 'invoice number', type: 'text' },
      po_number: { label: 'PO number', type: 'text' },
    };

    const oldVals = activity?.old_values || {};
    const newVals = activity?.new_values || {};

    const format = (value: any, type: string): string => {
      if (value === null || value === undefined || value === '') {
        return '';
      }
      return type === 'date'
        ? (this.datePipe.transform(value, 'dd MMM yyyy') || `${value}`)
        : `${value}`;
    };

    const phrases = Object.keys(newVals)
      .filter((key: string) => fields[key])
      .map((key: string) => {
        const { label, type } = fields[key];
        const oldText = format(oldVals[key], type);
        const newText = format(newVals[key], type);

        if (!oldText && newText) {
          return `set the ${label} to ${newText}`;
        }
        if (oldText && !newText) {
          return `cleared the ${label}`;
        }
        return `changed the ${label} from ${oldText} to ${newText}`;
      });

    if (!phrases.length) {
      return 'edited the invoice';
    }
    if (phrases.length === 1) {
      return phrases[0];
    }
    return `${phrases.slice(0, -1).join(', ')} and ${phrases[phrases.length - 1]}`;
  }

  close() {
    this.dialogRef.close();
  }
}
